// extracted by mini-css-extract-plugin
export default {"arrowIcon":"rKwUG9"};